export { history } from './history';

export const RoutePath = {
  root: '/',
  loginRedirect: '/login',
  permissionDenied: '/permission-denied',

  // Configuration
  configurationRoot: '/configuration',

  configurationTemplateDefinitionRoot: '/configuration/template',
  configurationTemplateDefinitionList: '/configuration/template/list',
  configurationTemplateDefinitionEditRoot: '/configuration/template/scheme/:schemeId/edit',
  configurationTemplateDefinitionEditSalaryTypesRoot: '/configuration/template/scheme/:schemeId/edit/salary-types',
  configurationTemplateDefinitionEditSalaryTypesList: '/configuration/template/scheme/:schemeId/edit/salary-types/list',
  configurationTemplateDefinitionEditSalaryTypesCreate:
    '/configuration/template/scheme/:schemeId/edit/salary-types/create',
  configurationTemplateDefinitionEditSalaryTypesEdit:
    '/configuration/template/scheme/:schemeId/edit/salary-types/:schemeSalaryTypeId/edit',
  configurationTemplateDefinitionEditTemplateTypeUpdate:
    '/configuration/template/scheme/:schemeId/edit/upload-template-type',

  configurationMemberRequestSettings: '/configuration/member-request-settings',

  configurationAdminSyncRoot: '/configuration/admin-platform',
  configurationAdminSyncList: '/configuration/admin-platform/list',
  configurationAdminSyncViewEditEmployer:
    '/configuration/admin-platform/employer/:employerId/admin-sync/:action/details',
  configurationAdminSyncViewEditEmployerAudit:
    '/configuration/admin-platform/employer/:employerId/admin-sync/:action/audit',

  configurationValidationsRoot: '/configuration/validations',
  configurationValidationsList: '/configuration/validations/list',
  configurationValidationViewRoot: '/configuration/validations/:validationId/view',
  configurationValidationViewDetail: '/configuration/validations/:validationId/view/detail',
  configurationValidationViewAudit: '/configuration/validations/:validationId/view/audit',
  configurationValidationEditRoot: '/configuration/validations/:validationId/edit',
  configurationValidationEditDetail: '/configuration/validations/:validationId/edit/detail',
  configurationValidationEditAudit: '/configuration/validations/:validationId/edit/audit',

  configurationPayrollsRoot: '/configuration/payrolls',
  configurationPayrollsList: '/configuration/payrolls/list',
  configurationPayrollsAddRoot: '/configuration/payrolls/add',
  configurationPayrollsAddDetail: '/configuration/payrolls/add/detail',
  configurationPayrollsAddMandate: '/configuration/payrolls/add/direct-debit',
  configurationPayrollsAddSummary: '/configuration/payrolls/add/summary',

  configurationPayrollViewRoot: '/configuration/payrolls/:payrollId/view',
  configurationPayrollViewDetail: '/configuration/payrolls/:payrollId/view/detail',
  configurationPayrollViewPeriod: '/configuration/payrolls/:payrollId/view/period',
  configurationPayrollViewDirectDebit: '/configuration/payrolls/:payrollId/view/direct-debit',
  configurationPayrollViewDirectDebitSummary:
    '/configuration/payrolls/:payrollId/view/direct-debit/:directDebitId/summary',
  configurationPayrollViewRestriction: '/configuration/payrolls/:payrollId/view/restriction',
  configurationPayrollViewAudit: '/configuration/payrolls/:payrollId/view/audit',
  configurationPayrollEditRoot: '/configuration/payrolls/:payrollId/edit',
  configurationPayrollEditDetail: '/configuration/payrolls/:payrollId/edit/detail',
  configurationPayrollEditPeriod: '/configuration/payrolls/:payrollId/edit/period',
  configurationPayrollEditDirectDebit: '/configuration/payrolls/:payrollId/edit/direct-debit',
  configurationPayrollEditDirectDebitSummary:
    '/configuration/payrolls/:payrollId/edit/direct-debit/:directDebitId/summary',
  configurationPayrollEditDirectDebitSetup: '/configuration/payrolls/:payrollId/edit/direct-debit/setup',
  configurationPayrollEditDirectDebitSetupSummary: '/configuration/payrolls/:payrollId/edit/direct-debit/setup/summary',
  configurationPayrollEditRestriction: '/configuration/payrolls/:payrollId/edit/restriction',
  configurationPayrollEditAudit: '/configuration/payrolls/:payrollId/edit/audit',

  // Data Management
  dataManagementRoot: '/data-management',
  dataManagementUploadHistoryList: '/data-management/upload-history/list',
  dataManagementUploadHistoryUploadData: '/data-management/upload-history/upload-data',
  dataManagementUploadHistoryDetailsRoot: '/data-management/upload-history/:fileId/details',
  dataManagementUploadHistoryDetailsSummary: '/data-management/upload-history/:fileId/details/summary',
  dataManagementUploadHistoryDetailsAudit: '/data-management/upload-history/:fileId/details/audit',
  dataManagementUploadHistoryDetailsDownloadAudit: '/data-management/upload-history/:fileId/details/download-audit',
  dataManagementUploadHistoryDetailsAdminSynchronisationDetails:
    '/data-management/upload-history/:fileId/details/admin-sync-details',
  dataManagementDataAmendmentsRoot: '/data-management/data-amendments',
  dataManagementDataAmendmentsUpload: '/data-management/data-amendments/upload',
  dataManagementDataAmendmentsHistory: '/data-management/data-amendments/history',

  dataManagementValidationHelperList: '/data-management/validation-helper',

  dataManagementMemberList: '/data-management/member/list',
  dataManagementMemberRequest: '/data-management/member/member-request',
  dataManagementMemberViewEditRoot: '/data-management/member/:employeeId/:action',
  dataManagementMemberViewEditMembershipDetails: '/data-management/member/:employeeId/:action/membership',
  dataManagementMemberViewEditMembershipPersonalDetails:
    '/data-management/member/:employeeId/:action/membership/personal-details',
  dataManagementMemberViewEditMembershipAccountDetails:
    '/data-management/member/:employeeId/:action/membership/account-details',
  dataManagementMemberViewEditMembershipAutoEnrolmentDetails:
    '/data-management/member/:employeeId/:action/membership/auto-enrolment-details',
  dataManagementMemberViewEditMembershipLastMembershipMemberRequestDetails:
    '/data-management/member/:employeeId/:action/membership/member-request/:requestId/details',
  dataManagementMemberViewEditMembershipHistoryRoot:
    '/data-management/member/:employeeId/:action/membership/history/:membershipId',
  dataManagementMemberViewEditMembershipHistoryDetails:
    '/data-management/member/:employeeId/:action/membership/history/:membershipId/details',
  dataManagementMemberViewEditMembershipHistoryMemberRequestDetails:
    '/data-management/member/:employeeId/:action/membership/history/:membershipId/member-request/:requestId/details',

  dataManagementMemberViewEditEmploymentDetails: '/data-management/member/:employeeId/:action/employment',
  dataManagementMemberViewEditEmploymentGeneralDetails:
    '/data-management/member/:employeeId/:action/employment/general-details',

  dataManagementMemberViewEditEmploymentSalaryDetailsRoot:
    '/data-management/member/:employeeId/:action/employment/salary-details',
  dataManagementMemberViewEditEmploymentSalaryDetailsList:
    '/data-management/member/:employeeId/:action/employment/salary-details/list',
  dataManagementMemberViewEditEmploymentSalaryDetailsCreate:
    '/data-management/member/:employeeId/:action/employment/salary-details/create',
  dataManagementMemberViewEditEmploymentSalaryDetailsEdit:
    '/data-management/member/:employeeId/:action/employment/salary-details/:salaryDetailId/edit',

  dataManagementMemberViewEditEmploymentPartTimeRoot:
    '/data-management/member/:employeeId/:action/employment/part-time',
  dataManagementMemberViewEditEmploymentPartTimeList:
    '/data-management/member/:employeeId/:action/employment/part-time/list',
  dataManagementMemberViewEditEmploymentPartTimeDetailsCreate:
    '/data-management/member/:employeeId/:action/employment/part-time/create',
  dataManagementMemberViewEditEmploymentPartTimeDetailsView:
    '/data-management/member/:employeeId/:action/employment/part-time/:partTimeId/view/details',
  dataManagementMemberViewEditEmploymentPartTimeDetailsEdit:
    '/data-management/member/:employeeId/:action/employment/part-time/:partTimeId/edit/details',

  dataManagementMemberViewEditEmploymentBreakInServiceRoot:
    '/data-management/member/:employeeId/:action/employment/break-in-service',
  dataManagementMemberViewEditEmploymentBreakInServiceList:
    '/data-management/member/:employeeId/:action/employment/break-in-service/list',
  dataManagementMemberViewEditEmploymentBreakInServiceDetailsCreate:
    '/data-management/member/:employeeId/:action/employment/break-in-service/create',
  dataManagementMemberViewEditEmploymentBreakInServiceDetailsView:
    '/data-management/member/:employeeId/:action/employment/break-in-service/:breakInServiceId/view/details',
  dataManagementMemberViewEditEmploymentBreakInServiceDetailsEdit:
    '/data-management/member/:employeeId/:action/employment/break-in-service/:breakInServiceId/edit/details',

  dataManagementMemberViewEditContributions: '/data-management/member/:employeeId/:action/contributions',
  dataManagementMemberViewEditContributionsAmountList:
    '/data-management/member/:employeeId/:action/contributions/amount',
  dataManagementMemberViewEditContributionsRateList: '/data-management/member/:employeeId/:action/contributions/rate',
  dataManagementMemberViewEditContributionsCappedContributionList:
    '/data-management/member/:employeeId/:action/contributions/capped-contribution',

  dataManagementMemberViewEditAuditRoot: '/data-management/member/:employeeId/:action/audit',
  dataManagementMemberViewEditAuditList: '/data-management/member/:employeeId/:action/audit/list',
  dataManagementMemberViewEditAuditDetails: '/data-management/member/:employeeId/:action/audit/:auditId/details',

  dataManagementSchemeAuditRoot: '/data-management/scheme-audit',
  dataManagementSchemeAuditAudit: '/data-management/scheme-audit/audit',
  dataManagementSchemeAuditAuditDetails: '/data-management/scheme-audit/audit/:auditId/details',
  dataManagementSchemeAuditAdminSync: '/data-management/scheme-audit/admin-sync',
  dataManagementSchemeAuditAdminSyncDetails: '/data-management/scheme-audit/admin-sync/:dataSyncId/details',

  // Analytics & Reports
  reportingRoot: '/reporting',
  reportingReportsRoot: '/reporting/reports',
  reportingReportsList: '/reporting/reports/list',
  reportingReportsCreate: '/reporting/reports/create',
  reportingReportsEdit: '/reporting/reports/edit/:reportId',

  reportingHistoryRoot: '/reporting/history',
  reportingHistoryList: '/reporting/history/list',
  reportingHistoryView: '/reporting/history/view/:extractId',

  reportingLatePaymentReportRoot: '/reporting/late-payment-report',
  reportingLatePaymentReportList: '/reporting/late-payment-report/list',
  reportingLatePaymentReportDetail: '/reporting/late-payment-report/view/:payrollPeriodId',

  reportingRequestsList: '/reporting/requests/list',

  reportingPayrollSummaryReportRoot: '/reporting/payroll-summary-report',
  reportingPayrollSummaryReportReport: '/reporting/payroll-summary-report/report',
  reportingPayrollSummaryReportAudit: '/reporting/payroll-summary-report/audit',

  reportingValidationInsightsRoot: '/reporting/validation-insights',

  // Product Information
  productInfo: '/product-info',

  // Audit
  audit: '/audit',
};

export { GuardedRoute } from './GuardedRoute';
export { routeAccess } from './routeAccess';
